import {GetAssignedSegmentsRequest, GetAssignedSegmentsResponse} from '@/types/AssignedSegment'
import {getAssignedSegmentsService} from '../services/journeysService'

export type GetAssignedSegmentParams = {
  country: string
  query?: string
}

export async function getAssignedSegmentsUseCase(
  params: GetAssignedSegmentsRequest,
  signal?: AbortSignal
): Promise<GetAssignedSegmentsResponse> {
  return getAssignedSegmentsService(params, signal)
}
